import { isValidRepub } from '@cx-web/utils';

import { type Repub, REPUBS } from '@cx-modules/constants';

export function getRepubFromURL(url: URL): Repub {
  const repub = url.pathname.split('/')[1]?.toUpperCase();
  if (!isValidRepub(repub) || !REPUBS[repub]) {
    return REPUBS.OC.name;
  }

  return repub;
}
